<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h5>Edit External SIP Profile</h5>
      </div>
    </div>
    <br>
    <div class="row">
      <div class="col-8">
        <form>
          <div class="form-group">
            <label for="txtName">Name</label>
            <input type="text" class="form-control" id="txtName" v-model="intercom_external_sip.name">
            <small class="form-text text-muted">.xml not required.</small>
          </div>
          <div class="form-group">
            <label for="txtConditionExpression">Condition Expression</label>
            <input type="text" class="form-control" id="txtConditionExpression" v-model="intercom_external_sip.condition_expression">
          </div>
          <div class="form-group">
            <label for="txtGateway">Gateway</label>
            <input type="text" class="form-control" id="txtGateway" v-model="intercom_external_sip.gateway">
          </div>
          <div class="form-group">
            <label for="txtUsername">Username</label>
            <input type="text" class="form-control" id="txtUsername" v-model="intercom_external_sip.username">
          </div>
          <div class="form-group">
            <label for="txtAuthUsername">Auth-Username</label>
            <input type="text" class="form-control" id="txtAuthUsername" v-model="intercom_external_sip.auth_username">
          </div>
          <div class="form-group">
            <label for="txtRealm">Realm</label>
            <input type="text" class="form-control" id="txtRealm" v-model="intercom_external_sip.realm">
          </div>
          <div class="form-group">
            <label for="txtPassword">Password</label>
            <input type="text" class="form-control" id="txtPassword" v-model="intercom_external_sip.password">
          </div>
          <div class="form-group">
            <label for="txtProxy">Proxy</label>
            <input type="text" class="form-control" id="txtProxy" v-model="intercom_external_sip.proxy">
          </div>
          <div class="form-group">
            <label for="txtExpireSeconds">Expire Seconds</label>
            <input type="text" class="form-control" id="txtExpireSeconds" v-model="intercom_external_sip.expire_seconds">
          </div>
          <div class="form-group">
            <label for="txtRegister">Register</label>
            <input type="text" class="form-control" id="txtRegister" v-model="intercom_external_sip.register">
          </div>
          <div class="form-group">
            <label for="txtRetrySeconds">Retry Seconds</label>
            <input type="text" class="form-control" id="txtRetrySeconds" v-model="intercom_external_sip.retry_seconds">
          </div>
          <div class="form-group">
            <label for="txtDtmfType">DTMF Type</label>
            <input type="text" class="form-control" id="txtDtmfType" v-model="intercom_external_sip.dtmf_type">
          </div>
          <button type="button" class="btn btn-hub-primary" @click="submit()">Submit</button>
          <router-link :to="{ name: 'AdminExternalSipIndex' }" class="btn btn-secondary">Cancel</router-link>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: [
    'intercom_external_sip_id'
  ],
  computed: {
    ...mapGetters({
      intercom_external_sip: 'singleIntercomExternalSip'
    })
  },
  created () {
    this.$store.dispatch('setDisabledChangeScopedSite', true)
    this.$store.dispatch('getIntercomExternalSip', this.intercom_external_sip_id)
  },
  methods: {
    submit () {
      this.$store.dispatch('addEditIntercomExternalSip', this.intercom_external_sip)
    }
  }
}
</script>

<style scoped>

</style>
